import React from "react";
import "./errorMsg.css";

const ErrorMsg = ({ errors }) => {
  let errorList = [];

  for (let property in errors) {
    const error = errors[property];
    const startLineNumber = error.startLineNumber;

    errorList.push(
      <div key={property} className="error-renderer">
        <span>
          <img src={require("../../assets/remove.png")} alt="Error icon" />
          {error.owner}
          {startLineNumber && `.${startLineNumber} :`} {error.startColumn} { error.lineNumber && ` html.${error.lineNumber} :`} {error.lineNumber}
        </span>
        <p>{error.message}</p>
      </div>
    );
  }

  return errorList;
};

export default ErrorMsg;
